// extracted by mini-css-extract-plugin
export default {"page":"kN","top_block":"lN","heading":"mN","inner_text":"nN","starter_text":"oN","starter_cta":"pN","summary_block":"qN","cartsummary_wrap":"rN","price":"sN","pricing_wrap":"tN","summary_block_mob":"uN","summary":"vN","pricing_heading":"wN","products_summary":"xN","summary_line":"yN","summary_price":"zN","summary_title":"AN"};
    if(module.hot) {
      // 1713996748667
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  